"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var LinkedIn = function LinkedIn() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M463,652.8H-49.2V141H463V652.8z M142.8,333h-64v224h64V333z M87.3,245.5c-25.9,34.4,12.6,73,47,47  C160.3,258.1,121.7,219.5,87.3,245.5z M366.8,413c0-44.2-32.2-80-72-80c-22.6,0-42.8,21.6-56,39.7V333h-64v224h64V429  c0-28,35.6-47.4,64-15.6V557h64V413z"
  }));
};

LinkedIn.displayName = 'LinkedIn';
var _default = LinkedIn;
exports["default"] = _default;
LinkedIn.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LinkedIn"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/LinkedIn.js"] = {
    name: "LinkedIn",
    docgenInfo: LinkedIn.__docgenInfo,
    path: "src/LinkedIn.js"
  };
}